import React from "react";

const Contactus = () => {
  return (
    <div>
      <h1>Contactus page</h1>
    </div>
  );
};

export default Contactus;
